import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  cameras: [],
  selectedCamera: null,
  loading: false,
  error: null
};

export const cctvSlice = createSlice({
  name: 'cctv',
  initialState,
  reducers: {
    fetchCamerasStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchCamerasSuccess: (state, action) => {
      state.cameras = action.payload;
      state.loading = false;
      state.error = null;
    },
    fetchCamerasFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    selectCamera: (state, action) => {
      state.selectedCamera = action.payload;
    }
  },
});

export const { 
  fetchCamerasStart, 
  fetchCamerasSuccess, 
  fetchCamerasFailure,
  selectCamera
} = cctvSlice.actions;

// 模擬獲取CCTV攝像頭數據
export const fetchCctvStreams = () => async (dispatch) => {
  try {
    dispatch(fetchCamerasStart());
    
    // 模擬API請求延遲
    await new Promise(resolve => setTimeout(resolve, 1000));
    
    // 模擬攝像頭數據
    const cameras = [
      {
        id: 'cam1',
        name: '正門入口',
        location: '大堂',
        status: 'online',
        streamUrl: 'https://example.com/stream/cam1',
        thumbnail: 'https://via.placeholder.com/320x180.png?text=入口監控',
        lastUpdated: new Date().toISOString()
      },
      {
        id: 'cam2',
        name: '後門入口',
        location: '後區',
        status: 'online',
        streamUrl: 'https://example.com/stream/cam2',
        thumbnail: 'https://via.placeholder.com/320x180.png?text=後門監控',
        lastUpdated: new Date().toISOString()
      },
      {
        id: 'cam3',
        name: '電梯大堂 - 地面層',
        location: '地面層',
        status: 'online',
        streamUrl: 'https://example.com/stream/cam3',
        thumbnail: 'https://via.placeholder.com/320x180.png?text=電梯監控',
        lastUpdated: new Date().toISOString()
      },
      {
        id: 'cam4',
        name: '停車場 - 入口',
        location: '地下一層',
        status: 'online',
        streamUrl: 'https://example.com/stream/cam4',
        thumbnail: 'https://via.placeholder.com/320x180.png?text=停車場入口',
        lastUpdated: new Date().toISOString()
      },
      {
        id: 'cam5',
        name: '停車場 - A區',
        location: '地下一層',
        status: 'online',
        streamUrl: 'https://example.com/stream/cam5',
        thumbnail: 'https://via.placeholder.com/320x180.png?text=停車場A區',
        lastUpdated: new Date().toISOString()
      },
      {
        id: 'cam6',
        name: '停車場 - B區',
        location: '地下一層',
        status: 'online',
        streamUrl: 'https://example.com/stream/cam6',
        thumbnail: 'https://via.placeholder.com/320x180.png?text=停車場B區',
        lastUpdated: new Date().toISOString()
      },
      {
        id: 'cam7',
        name: '垃圾房',
        location: '地面層',
        status: 'offline',
        streamUrl: 'https://example.com/stream/cam7',
        thumbnail: 'https://via.placeholder.com/320x180.png?text=垃圾房監控',
        lastUpdated: new Date(Date.now() - 86400000).toISOString()
      },
      {
        id: 'cam8',
        name: '花園區域',
        location: '地面層',
        status: 'online',
        streamUrl: 'https://example.com/stream/cam8',
        thumbnail: 'https://via.placeholder.com/320x180.png?text=花園監控',
        lastUpdated: new Date().toISOString()
      },
      {
        id: 'cam9',
        name: '天台',
        location: '頂層',
        status: 'maintenance',
        streamUrl: 'https://example.com/stream/cam9',
        thumbnail: 'https://via.placeholder.com/320x180.png?text=天台監控',
        lastUpdated: new Date(Date.now() - 172800000).toISOString()
      }
    ];
    
    dispatch(fetchCamerasSuccess(cameras));
    return { success: true, data: cameras };
  } catch (error) {
    dispatch(fetchCamerasFailure(error.message || '獲取監控攝像頭失敗'));
    return { success: false, error: error.message || '獲取監控攝像頭失敗' };
  }
};

export default cctvSlice.reducer; 